import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';
import { API_BASE_URL } from '../authentication/auth.interceptor';

export interface EnterpriseRole {
  readonly id: number;
  readonly name: string;
}

export interface EnterpriseBranch {
  readonly id: number;
  readonly code: string;
  readonly name: string;
}

export interface EnterpriseCompany {
  readonly id: number;
  readonly name: string;
  readonly logoUrl: string | null;
  readonly role: EnterpriseRole;
  readonly permissions: readonly string[];
  readonly allowedBranches: readonly EnterpriseBranch[];
}

export interface EnterpriseAccessResponse {
  readonly companies: readonly EnterpriseCompany[];
}

@Injectable({ providedIn: 'root' })
export class EnterpriseAccessApiService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL).replace(/\/$/, '');

  getEnterpriseAccess(): Observable<EnterpriseAccessResponse> {
    return this.http.get<EnterpriseAccessResponse>(
      `${this.apiBaseUrl}/context/access`,
    );
  }
}
